var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.836 16.0457C13.2751 16.3414 12.6457 16.5 12 16.5C10.9557 16.5 9.95419 16.0852 9.21577 15.3467C8.47734 14.6083 8.0625 13.6068 8.0625 12.5625V11.4375C8.0625 11.2883 8.00324 11.1452 7.89775 11.0398C7.79226 10.9343 7.64918 10.875 7.5 10.875C7.35082 10.875 7.20774 10.9343 7.10225 11.0398C6.99676 11.1452 6.9375 11.2883 6.9375 11.4375V12.5625C6.93752 13.8078 7.39647 15.0094 8.22663 15.9377C9.05678 16.866 10.1999 17.4557 11.4375 17.5942V19.3125H9.1875C9.03832 19.3125 8.89524 19.3718 8.78975 19.4773C8.68426 19.5827 8.625 19.7258 8.625 19.875C8.625 20.0242 8.68426 20.1673 8.78975 20.2727C8.89524 20.3782 9.03832 20.4375 9.1875 20.4375H14.8125C14.9617 20.4375 15.1048 20.3782 15.2102 20.2727C15.3157 20.1673 15.375 20.0242 15.375 19.875C15.375 19.7258 15.3157 19.5827 15.2102 19.4773C15.1048 19.3718 14.9617 19.3125 14.8125 19.3125H12.5625V17.5942C13.2989 17.5118 14.0019 17.2696 14.6253 16.8914L13.836 16.0457ZM17.0515 12.8958C17.0588 12.7851 17.0625 12.674 17.0625 12.5625V11.4375C17.0625 11.2883 17.0032 11.1452 16.8977 11.0398C16.7923 10.9343 16.6492 10.875 16.5 10.875C16.3508 10.875 16.2077 10.9343 16.1023 11.0398C15.9968 11.1452 15.9375 11.2883 15.9375 11.4375V11.7022L17.0515 12.8958Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65417 4.82346L14.8125 10.3502V6.375C14.8125 5.62908 14.5162 4.91371 13.9887 4.38626C13.4613 3.85882 12.7459 3.5625 12 3.5625C11.2541 3.5625 10.5387 3.85882 10.0113 4.38626C9.87686 4.52066 9.75747 4.66726 9.65417 4.82346ZM13.0283 15.1803L9.1875 11.0652V12.5625C9.1875 13.3084 9.48382 14.0238 10.0113 14.5512C10.5387 15.0787 11.2541 15.375 12 15.375C12.3554 15.375 12.7038 15.3077 13.0283 15.1803Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.06011,
    y1: 6.0342,
    x2: 17.2842,
    y2: 16.9399,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroMute);
export default __webpack_public_path__ + "static/media/micro-mute.aa9c6210a68c20c18648d102de47f05d.svg";
export { ForwardRef as ReactComponent };